// Fixed Asset Types Vuex

import state from './fixedTypeStates.js'
import * as getters from './fixedTypeGetters.js'
import * as mutations from './fixedTypeMutations.js'
import * as actions from './fixedTypeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
